var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCardWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 82,
    viewBox: "0 0 360 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.128832 74.1634C137.22 102.001 215.248 39.9888 360 63.0802L360 6.29444e-05C360 6.29444e-05 0.128781 2.25143e-08 0.028175 4.92378e-09C-0.0724312 -1.26668e-08 0.128832 74.0525 0.128832 74.1634Z",
    fill: "#48EC86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCardWave);
export default __webpack_public_path__ + "static/media/green-card-wave.67972ba563d5a5a5019f3f90d1d61a95.svg";
export { ForwardRef as ReactComponent };